
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M2 4.49h1.5m0 0v9.52c0 .395.153.774.425 1.053.273.28.642.437 1.027.437h7.096c.385 0 .755-.157 1.027-.437s.425-.658.425-1.054V4.491zm0 0H15M6 4V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1"}})])
          )
        }
      }
    